(function () {
  'use strict';

  var WORDS = ['Prices.', 'Quality.', 'Selection.', 'Value.'];
  var HOLD  = 2800;  // ms each word is shown
  var OUT   = 260;   // ms fade-out duration

  function findHeroJumbo() {
    return document.querySelector('.hero-wrapper jumbo-text');
  }

  function setup(el) {
    var line = el.querySelector('.jumbo-text-line');
    if (!line || line.querySelector('.sk-flip-word')) return;

    var text  = line.textContent.trim();
    var PIVOT = 'Better Food. Better ';
    var cut   = text.indexOf(PIVOT);
    if (cut === -1) return;

    var prefix = text.slice(0, cut + PIVOT.length);

    // Single span — we swap its text, never add a second one
    line.innerHTML = prefix + '<span class="sk-flip-word">' + WORDS[0] + '</span>';

    var word = line.querySelector('.sk-flip-word');
    var idx  = 0;

    // Prime the transition property
    word.style.transition = 'opacity ' + OUT + 'ms ease, transform ' + OUT + 'ms ease';
    word.style.opacity    = '1';
    word.style.transform  = 'translateY(0)';

    setInterval(function () {
      idx = (idx + 1) % WORDS.length;

      // --- FADE OUT + SLIDE UP ---
      word.style.opacity   = '0';
      word.style.transform = 'translateY(-10px)';

      setTimeout(function () {
        // Snap to bottom (no transition) then swap text
        word.style.transition = 'none';
        word.style.transform  = 'translateY(10px)';
        word.textContent       = WORDS[idx];

        // Force reflow so the snap is applied before we re-enable transitions
        // eslint-disable-next-line no-unused-expressions
        word.offsetHeight;

        // --- FADE IN + SLIDE UP TO REST ---
        word.style.transition = 'opacity ' + OUT + 'ms ease, transform ' + OUT + 'ms ease';
        word.style.opacity    = '1';
        word.style.transform  = 'translateY(0)';
      }, OUT + 20);

    }, HOLD);
  }

  function init() {
    var el = findHeroJumbo();
    if (!el) return;

    if (el.classList.contains('ready')) {
      setTimeout(function () { setup(el); }, 100);
    } else {
      var mo = new MutationObserver(function () {
        if (el.classList.contains('ready')) {
          mo.disconnect();
          setTimeout(function () { setup(el); }, 100);
        }
      });
      mo.observe(el, { attributes: true, attributeFilter: ['class'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
